import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "container-fix-padding" }
const _hoisted_2 = {
  key: 0,
  class: "p-1",
  style: { width: '100%' }
}
const _hoisted_3 = {
  key: 2,
  class: "lessonComment container bg-white border border-primary rounded-3 mt-3 p-3"
}
const _hoisted_4 = {
  class: "modal fade lessonTabModal",
  id: "ai_chat",
  tabindex: "-1",
  "aria-labelledby": "AIチャット",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "modal-dialog slideUpModal modal-dialog-scrollable modal-fullscreen bg-white" }
const _hoisted_6 = { class: "modal-content" }
const _hoisted_7 = { class: "modal-body pe-5" }
const _hoisted_8 = { xs12: "" }
const _hoisted_9 = { class: "bg-white border border-primary rounded-3 mt-3 p-3" }
const _hoisted_10 = {
  key: 1,
  class: "p-1"
}
const _hoisted_11 = { class: "bg-white border border-primary rounded-3 mt-3 p-3" }
const _hoisted_12 = { xs12: "" }

import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import UserGoal from '../../../api/v2/models/user_goal'
import api from '../../../api/v2/api'
import { format, getDay } from 'date-fns'
import { headerState } from '../../stores/header'
import GoalMilestoneWeb from '../atoms_molecules/GoalMilestoneWeb.vue'
import GoalMilestoneMobile from '../atoms_molecules/GoalMilestoneMobile.vue'
import UserGoalSuggestion from '../atoms_molecules/UserGoalSuggestion.vue'
import UserGoalAi from '../atoms_molecules/UserGoalAi.vue'
import GoalSummary from '../atoms_molecules/GoalSummary.vue'
import NextMilestoneCard from '../atoms_molecules/NextMilestoneCard.vue'
import MesageContainer from '../organisms/MesageContainer.vue'
import { checkMobile } from '../../utils/utils'
import { ROUTER_NAME } from '../../router'
import { rememberExamGoal } from '../../utils/exam_goal_context'
import ThreadContainer from "../organisms/ThreadContainer.vue"
import Splitter from 'primevue/splitter'
import SplitterPanel from 'primevue/splitterpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserGoalDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Refs
const mesageContainer = ref<InstanceType<typeof MesageContainer> | null>(null)

// Reactive Data
const userGoal = ref<UserGoal | null>(null)
const tab = ref<string | null>('chat')
const tabSelected = ref<number | null>(null)
const mobile = ref(checkMobile())

// Computed
const breadcrumbs = computed(() => [
  {
    text: 'ゴール一覧',
    disabled: false,
    exact: true,
    to: '/classroom/user-goals/'
  },
  {
    text: userGoal.value ? userGoal.value.goal.name : '',
    disabled: true
  }
])

const schoolSetting = computed(() => headerState.schoolSetting)

// 次にやること：期限切れ・やり直し・取り組み中のうち期限のいちばん早い宿題。無ければ先生の確認待ちのもの
const nextMilestone = computed(() => {
  const milestones = userGoal.value?.milestones ?? []
  return milestones.find((m) => m.status && ['overdue', 'retry', 'assigned'].includes(m.status)) ??
    milestones.find((m) => m.status === 'passed') ?? null
})

// Functions
function dateFormat(date: string, formatDate: string = 'MM/DD'): string {
  return format(date, formatDate)
}

function dateOfWeek(date: string): string {
  const japanDays: Record<number, string> = {
    0: '日曜',
    1: '月曜',
    2: '火曜',
    3: '水曜',
    4: '木曜',
    5: '金曜',
    6: '土曜'
  }
  return japanDays[getDay(date) || 0]
}

function toCourse(id: string) {
  router.push({
    name: ROUTER_NAME.MY_COURSE_DETAIL,
    params: {
      courseId: id
    },
  })
}

// ゴールの画面から教材へ（教材の画面の「戻る」でゴールに戻れるように、GoalMilestoneWeb と同じく元の画面を覚える）
function toCourseFromGoal(id: string) {
  sessionStorage.setItem('previousPage', route.path)
  toCourse(id)
}

// ゴールの中のテストとして開く（テストの画面・結果の画面の「戻る」がこのゴールに戻る）
function toExam(id: string) {
  if (userGoal.value) rememberExamGoal(id, userGoal.value.id, userGoal.value.goal.name)
  router.push({
    name: ROUTER_NAME.USER_GOAL_DETAIL_EXAM,
    params: {
      userGoalId: String(route.params.userGoalId),
      examId: id
    },
  })
}

function updateParentTab(value: number) {
  tab.value = value === 0 ? 'chat' : 'thread'
}

function emitCreateThread(value: number) {
  // Switch to chat tab when creating thread
  tab.value = value === 0 ? 'chat' : 'chat'
  mesageContainer.value?.createThread()
}

// Created logic
;(async () => {
  userGoal.value = await api.userGoal.show(route.params.userGoalId as string)
  headerState.setTitle(userGoal.value.goal.name)
  api.userGoal.saveActivity(route.params.userGoalId as string)
})()

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (userGoal.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (mobile.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(GoalSummary, { userGoal: userGoal.value }, null, 8 /* PROPS */, ["userGoal"]),
                (nextMilestone.value)
                  ? (_openBlock(), _createBlock(NextMilestoneCard, {
                      key: 0,
                      milestone: nextMilestone.value,
                      onToCourse: toCourseFromGoal,
                      onToExam: toExam
                    }, null, 8 /* PROPS */, ["milestone"]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" TODO: UserGoalSuggestionを表示する条件を追加する "),
                (false && userGoal.value.latestJoinedExams && userGoal.value.latestJoinedExams.length > 0)
                  ? (_openBlock(), _createBlock(UserGoalSuggestion, {
                      key: 1,
                      class: "mt-3",
                      userGoal: userGoal.value
                    }, null, 8 /* PROPS */, ["userGoal"]))
                  : _createCommentVNode("v-if", true),
                (schoolSetting.value && schoolSetting.value.useAiChatLesson)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                      _cache[11] || (_cache[11] = _createElementVNode("button", {
                        "aria-label": "AIチャット",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#ai_chat",
                        class: "w-100"
                      }, [
                        _createElementVNode("div", { class: "d-flex justify-content-between align-items-center fs-6" }, [
                          _createElementVNode("span", { class: "text-dark" }, " AIチャット "),
                          _createElementVNode("i", { class: "bi bi-chevron-expand" })
                        ])
                      ], -1 /* CACHED */)),
                      _createCommentVNode(" Modal "),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "modal-header" }, [
                              _createElementVNode("div", {
                                class: "h5 mb-0 modal-title",
                                id: "ai_chatLabel"
                              }, " AIチャット "),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-close",
                                "data-bs-dismiss": "modal",
                                "aria-label": "Close"
                              })
                            ], -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_v_tabs, {
                                  modelValue: tab.value,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event))
                                }, {
                                  default: _withCtx(() => [
                                    (userGoal.value.id && schoolSetting.value && schoolSetting.value.useAiChatGoal)
                                      ? (_openBlock(), _createBlock(_component_v_tab, {
                                          key: 0,
                                          value: "chat"
                                        }, {
                                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                            _createTextVNode("チャット", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    (userGoal.value.id && schoolSetting.value && schoolSetting.value.useAiChatGoal)
                                      ? (_openBlock(), _createBlock(_component_v_tab, {
                                          key: 1,
                                          value: "thread"
                                        }, {
                                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                            _createTextVNode("スレッド", -1 /* CACHED */)
                                          ]))]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"padding-right":"40px"} }, null, -1 /* CACHED */)),
                                    (schoolSetting.value && schoolSetting.value.useAiChatGoal)
                                      ? (_openBlock(), _createBlock(_component_v_btn, {
                                          key: 2,
                                          class: "btn-new-chat",
                                          icon: "",
                                          onClick: _cache[0] || (_cache[0] = ($event: any) => (emitCreateThread(1)))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, null, {
                                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                _createTextVNode("mdi-comment-plus", -1 /* CACHED */)
                                              ]))]),
                                              _: 1 /* STABLE */
                                            })
                                          ]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"]),
                                _createVNode(_component_v_window, {
                                  modelValue: tab.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event)),
                                  class: "h-full"
                                }, {
                                  default: _withCtx(() => [
                                    (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                      ? (_openBlock(), _createBlock(_component_v_window_item, {
                                          key: 0,
                                          value: "chat"
                                        }, {
                                          default: _withCtx(() => [
                                            (userGoal.value.id && schoolSetting.value && schoolSetting.value.useAiChatGoal)
                                              ? (_openBlock(), _createBlock(MesageContainer, {
                                                  class: "h-100",
                                                  key: userGoal.value.id,
                                                  targetableId: userGoal.value.id,
                                                  targetableType: 'UserGoal',
                                                  "using-deepseek": schoolSetting.value.usingDeepSeek
                                                }, null, 8 /* PROPS */, ["targetableId", "using-deepseek"]))
                                              : _createCommentVNode("v-if", true)
                                          ]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true),
                                    (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                      ? (_openBlock(), _createBlock(_component_v_window_item, {
                                          key: 1,
                                          value: "thread"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(), _createBlock(ThreadContainer, {
                                              key: tabSelected.value,
                                              targetableId: tabSelected.value,
                                              targetableType: 'UserGoal',
                                              onUpdateParentTab: updateParentTab,
                                              style: {"height":"calc(76vh + 40px)"},
                                              class: "h-full"
                                            }, null, 8 /* PROPS */, ["targetableId"]))
                                          ]),
                                          _: 1 /* STABLE */
                                        }))
                                      : _createCommentVNode("v-if", true)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue"])
                              ])
                            ]),
                            _createCommentVNode(" /.modal-body ")
                          ])
                        ])
                      ]),
                      _createCommentVNode(" /.modal "),
                      _createCommentVNode(" ///.END Modal ")
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" <UserGoalAi class=\"mt-3\" /> "),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userGoal.value.milestones, (milestone, index) => {
                    return (_openBlock(), _createBlock(GoalMilestoneMobile, {
                      key: milestone.id,
                      milestone: milestone,
                      isFirst: index == 0,
                      isLast: index == userGoal.value.milestones.length - 1,
                      onToCourse: toCourse,
                      onToExam: toExam
                    }, null, 8 /* PROPS */, ["milestone", "isFirst", "isLast"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_unref(Splitter), {
                  style: {"min-height":"100vh"},
                  class: "user-goal-splitter"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SplitterPanel), {
                      size: 70,
                      minSize: 30,
                      class: "left-panel"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(GoalSummary, { userGoal: userGoal.value }, null, 8 /* PROPS */, ["userGoal"]),
                        (nextMilestone.value)
                          ? (_openBlock(), _createBlock(NextMilestoneCard, {
                              key: 0,
                              milestone: nextMilestone.value,
                              onToCourse: toCourseFromGoal,
                              onToExam: toExam
                            }, null, 8 /* PROPS */, ["milestone"]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" TODO: UserGoalSuggestionを表示する条件を追加する "),
                        (false && userGoal.value.latestJoinedExams && userGoal.value.latestJoinedExams.length > 0)
                          ? (_openBlock(), _createBlock(UserGoalSuggestion, {
                              key: 1,
                              class: "mt-3",
                              userGoal: userGoal.value
                            }, null, 8 /* PROPS */, ["userGoal"]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" <UserGoalAi class=\"mt-3\" /> "),
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userGoal.value.milestones, (milestone, index) => {
                            return (_openBlock(), _createBlock(GoalMilestoneWeb, {
                              key: milestone.id,
                              milestone: milestone,
                              isFirst: index == 0,
                              isLast: index == userGoal.value.milestones.length - 1,
                              onToCourse: toCourse,
                              onToExam: toExam
                            }, null, 8 /* PROPS */, ["milestone", "isFirst", "isLast"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    (schoolSetting.value && schoolSetting.value.useAiChatGoal)
                      ? (_openBlock(), _createBlock(_unref(SplitterPanel), {
                          key: 0,
                          size: 30,
                          minSize: 20,
                          class: "right-panel"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_v_tabs, {
                                modelValue: tab.value,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tab).value = $event))
                              }, {
                                default: _withCtx(() => [
                                  (userGoal.value.id && schoolSetting.value && schoolSetting.value.useAiChatGoal)
                                    ? (_openBlock(), _createBlock(_component_v_tab, {
                                        key: 0,
                                        value: "chat"
                                      }, {
                                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                          _createTextVNode("チャット", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  (userGoal.value.id && schoolSetting.value && schoolSetting.value.useAiChatGoal)
                                    ? (_openBlock(), _createBlock(_component_v_tab, {
                                        key: 1,
                                        value: "thread"
                                      }, {
                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                          _createTextVNode("スレッド", -1 /* CACHED */)
                                        ]))]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"padding-right":"40px"} }, null, -1 /* CACHED */)),
                                  (schoolSetting.value && schoolSetting.value.useAiChatGoal)
                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                        key: 2,
                                        class: "btn-new-chat",
                                        icon: "",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (emitCreateThread(0)))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                              _createTextVNode("mdi-comment-plus", -1 /* CACHED */)
                                            ]))]),
                                            _: 1 /* STABLE */
                                          })
                                        ]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["modelValue"]),
                              _createVNode(_component_v_window, {
                                modelValue: tab.value,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tab).value = $event)),
                                class: "h-full"
                              }, {
                                default: _withCtx(() => [
                                  (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                    ? (_openBlock(), _createBlock(_component_v_window_item, {
                                        key: 0,
                                        value: "chat"
                                      }, {
                                        default: _withCtx(() => [
                                          (userGoal.value.id && schoolSetting.value && schoolSetting.value.useAiChatGoal)
                                            ? (_openBlock(), _createBlock(MesageContainer, {
                                                ref_key: "mesageContainer",
                                                ref: mesageContainer,
                                                style: {"height":"83vh"},
                                                key: userGoal.value.id,
                                                targetableId: userGoal.value.id,
                                                targetableType: 'UserGoal',
                                                "using-deepseek": schoolSetting.value.usingDeepSeek
                                              }, null, 8 /* PROPS */, ["targetableId", "using-deepseek"]))
                                            : _createCommentVNode("v-if", true)
                                        ]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true),
                                  (schoolSetting.value && schoolSetting.value.useAiChatExam)
                                    ? (_openBlock(), _createBlock(_component_v_window_item, {
                                        key: 1,
                                        value: "thread"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(ThreadContainer, {
                                            key: userGoal.value.id,
                                            targetableId: userGoal.value.id,
                                            targetableType: 'UserGoal',
                                            parentTab: 0,
                                            onUpdateParentTab: updateParentTab,
                                            style: {"height":"83vh"}
                                          }, null, 8 /* PROPS */, ["targetableId"]))
                                        ]),
                                        _: 1 /* STABLE */
                                      }))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["modelValue"])
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})